const lang: any = {
    registerPlant: {
        PT: 'Cadastrar Nova Planta',
        US: 'Register New Plant',
        ES: 'Registrar Nueva Planta'
    },

    editPlant: {
        PT: 'Editar Planta',
        US: 'Edit Plant',
        ES: 'Editar Planta'
    },

    plantInfo: {
        PT: 'INFORMAÇÕES DA PLANTA',
        US: 'PLANT INFO',
        ES: 'INFORMACIÓN DE LA PLANTA'
    },

    formRegister: {
        PT: 'Formulário de cadastro',
        US: 'Registration form',
        ES: 'Formulario de registro'
    },

    formMessage: {
        PT: 'Insira um email e uma mensagem para serem enviados ou copie o link e envie diretamente',
        US: 'Enter an email and a message to be sent, or copy the link and send it directly',
        ES: 'Introduzca un correo electrónico y un mensaje para enviar, o copie el enlace y envíelo directamente'
    },

    emailMsg: {
        PT: "Prezado(a),\n\nPor favor, preencha o formulário disponível no link abaixo para fornecer informações necessárias sobre o ativo. Sua colaboração é importante para nós.\n\nAgradecemos sua atenção e colaboração.\n\nAtenciosamente,\nIntegrAtivos",
        US: "Dear [Sir/Madam],\n\nPlease fill out the form available at the link below to provide necessary information about the asset. Your cooperation is important to us.\n\nThank you for your attention and cooperation.\n\nSincerely,\nIntegrAtivos",
        ES: "Estimado(a),\n\nPor favor, complete el formulario disponible en el enlace a continuación para proporcionar la información necesaria sobre el activo. Su colaboración es importante para nosotros.\n\nAgradecemos su atención y colaboración.\n\nAtentamente,\nIntegrAtivos"
    },

    formFillingRequest: {
        PT: "Solicitação de Preenchimento de Formulário",
        US: "Form Completion Request",
        ES: "Solicitud de Cumplimiento de Formulario"
    },
    plantCapture: {
        PT: 'IMAGEM CAPTURADA',
        US: 'IMAGE CAPTURED',
        ES: 'IMAGEN CAPTURADA'
    },
    next: {
        PT: 'Próximo',
        US: 'Next',
        ES: 'Siguiente'
    },
    plantMarker: {
        PT: 'INDIQUE O LOCAL DA PLANTA NO MAPA',
        US: 'SHOW THE PLANT LOCATION ON THE MAP',
        ES: 'INDICAR LA UBICACIÓN DEL PLANTA EN EL MAPA'
    },
    name: {
        PT: 'Nome',
        US: 'Name',
        ES: 'Nombre'
    },

    company: {
        PT: 'Empresa',
        US: 'Company',
        ES: 'Empresa'
    },

    location: {
        PT: 'Localização',
        US: 'Location',
        ES: 'Ubicación'
    },

    documents: {
        PT: 'Documentos',
        US: 'Documents',
        ES: 'Documentos'
    },

    photos: {
        PT: 'Fotos',
        US: 'Photos',
        ES: 'Fotos'
    },

    register: {
        PT: 'Cadastrar',
        US: 'Register',
        ES: 'Registrar'
    },

    edit: {
        PT: 'Editar',
        US: 'Edit',
        ES: 'Editar'
    },

    addNew: {
        PT: 'Adicionar Novo',
        US: 'Add New',
        ES: 'Agregar Nuevo'
    },
    plantRegistered: {
        PT: "Planta Cadastrada",
        US: "Plant Registered",
        ES: "Planta Registrada"
    },
    
    wantToRegisterProcess: {
        PT: "Deseja Cadastrar um Processo?",
        US: "Do You Want to Register a Process?",
        ES: "¿Desea Registrar un Proceso?"
    },
    close: {
        PT: "Fechar",
        US: "Close",
        ES: "Cerrar"
    },
    
    send: {
        PT: "Enviar",
        US: "Send",
        ES: "Enviar"
    },
    message: {
        PT: "Mensagem",
        US: "Message",
        ES: "Mensaje"
    },
    
    email: {
        PT: "Email",
        US: "Email",
        ES: "Correo Electrónico"
    },
    invalidEmail: {
        PT: "Email Inválido!",
        US: "Invalid Email!",
        ES: "¡Correo Electrónico Inválido!"
    },
    captureMap: {
        PT: "Capturar Mapa",
        US: "Capture Map",
        ES: "Capturar Mapa"
    },
    yes: {
        PT: "Sim",
        US: "Yes",
        ES: "Sí"
    },
    
    no: {
        PT: "Não",
        US: "No",
        ES: "No"
    },
    
}

export default lang;
